<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-office-building"></i> 部门管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 工具栏 -->
      <div class="toolbar">
        <div class="toolbar-left">
          <el-button type="primary" @click="addData" icon="el-icon-plus" size="small">新增部门</el-button>
        </div>
        <div class="toolbar-right">
          <el-input 
            v-model="searchForm.name" 
            placeholder="请输入部门名称"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            class="search-input"
            @keyup.enter.native="searchSubmit"
          ></el-input>
          <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
          <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-office-building"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">总部门数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon top">
            <i class="el-icon-s-home"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ topLevelCount }}</div>
            <div class="stat-label">一级部门</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon child">
            <i class="el-icon-s-operation"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ subLevelCount }}</div>
            <div class="stat-label">子部门</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          :data="tableLoadData"
          stripe
          border
          row-key="id"
          size="medium"
          :default-expand-all="true"
          :tree-props="{children: 'children'}"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column prop="name" label="部门名称" min-width="250">
            <template slot-scope="scope">
              <div class="dept-name">
                <i class="el-icon-office-building"></i>
                <span>{{ scope.row.name }}</span>
                <el-tag v-if="scope.row.pid === 0" size="small" type="success" effect="plain" class="level-tag">一级部门</el-tag>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="contact_name" label="负责人" width="150" align="center">
            <template slot-scope="scope">
              <div class="contact-info">
                <i class="el-icon-user"></i>
                <span>{{ scope.row.contact_name || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="mobile" label="联系电话" width="150" align="center">
            <template slot-scope="scope">
              <div class="phone-info">
                <i class="el-icon-phone"></i>
                <span>{{ scope.row.mobile || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="创建时间" width="180" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="handelEdit(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                class="delete-btn"
                @click="handelDel(scope.row)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-office-building"></i>
        <p>暂无部门数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="500px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right" size="small">
          <el-form-item label="上级部门" prop="pid">
            <el-cascader
              v-model="form.pid"
              :props="cascaderProps"
              :options="options"
              clearable
              :show-all-levels="false"
              @change="handleChange"
              placeholder="请选择上级部门（不选则为一级部门）"
              class="full-width"
            ></el-cascader>
            <div class="form-tip" v-if="!form.pid || form.pid.length === 0">
              <i class="el-icon-info"></i> 不选择上级部门将创建为一级部门
            </div>
          </el-form-item>

          <el-form-item label="部门名称" prop="name">
            <el-input 
              v-model="form.name" 
              placeholder="请输入部门名称"
              prefix-icon="el-icon-office-building"
              clearable
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item label="负责人" prop="contact_name">
            <el-input 
              v-model="form.contact_name" 
              placeholder="请输入负责人姓名"
              prefix-icon="el-icon-user"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="mobile">
            <el-input 
              v-model="form.mobile" 
              placeholder="请输入联系电话"
              prefix-icon="el-icon-phone"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "proxyDepartmentList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
        mobile: '',
        status: 0
      },
      
      // 统计数据
      totalCount: 0,
      topLevelCount: 0,
      subLevelCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 弹框控制
      dialogFormVisible: false,
      dialogTitle: '',
      
      // 表单数据
      form: {
        id: '',
        pid: '',
        name: '',
        mobile: '',
        contact_name: ''
      },
      
      // 部门树选项
      options: [],
      
      // 级联选择器配置
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: true
      },
      
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        mobile: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 计算统计数据
    calculateStats() {
      const countNodes = (data) => {
        let total = 0
        let topLevel = 0
        let subLevel = 0
        
        for (const item of data) {
          total++
          if (item.pid === 0 || !item.pid) {
            topLevel++
          } else {
            subLevel++
          }
          if (item.children && item.children.length) {
            const childStats = countNodes(item.children)
            total += childStats.total
            subLevel += childStats.subLevel
          }
        }
        return { total, topLevel, subLevel }
      }
      
      const stats = countNodes(this.tableLoadData)
      this.totalCount = stats.total
      this.topLevelCount = stats.topLevel
      this.subLevelCount = stats.subLevel
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 获取部门列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      
      if (this.searchForm.name) {
        param.name = this.searchForm.name
      }
      
      this.$axios.proxyDepartmentTree(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data || []
          this.options = this.tableLoadData
          this.total = res.data?.length || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    resetSearch() {
      this.searchForm.name = ''
      this.DataList()
    },
    
    // 新增部门
    addData() {
      this.dialogTitle = '新增部门'
      this.id = ''
      this.form = {
        id: '',
        pid: '',
        name: '',
        mobile: '',
        contact_name: ''
      }
      this.dialogFormVisible = true
    },
    
    // 编辑部门
    handelEdit(row) {
      this.dialogTitle = '编辑部门'
      this.id = row.id
      this.form = {
        id: row.id,
        pid: row.pid ? [row.pid] : [],
        name: row.name,
        mobile: row.mobile || '',
        contact_name: row.contact_name || ''
      }
      this.dialogFormVisible = true
    },
    
    // 删除部门
    handelDel(row) {
      let message = `确定要删除部门"${row.name}"吗？`
      if (row.children && row.children.length) {
        message = `部门"${row.name}"下有 ${row.children.length} 个子部门，删除后所有子部门也将被删除，是否继续？`
      }
      
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.id,
        }
        this.$axios.proxyDepartmentDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 上级部门变化
    handleChange(value) {
      if (value && value.length > 0) {
        this.form.pid = value[value.length - 1]
      } else {
        this.form.pid = ''
      }
    },
    
    // 弹框关闭回调
    handleDialogClosed() {
      this.$refs.form?.resetFields()
    },
    
    // 取消表单
    cancelForm() {
      this.dialogFormVisible = false
    },
    
    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = {
            pid: this.form.pid || 0,
            name: this.form.name,
            mobile: this.form.mobile,
            contact_name: this.form.contact_name,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            proxy_id: sessionStorage.getItem('proxy_id'),
          }
          
          if (this.form.id) {
            param.id = this.form.id
          }
          
          this.$axios.proxyDepartmentSave(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.DataList()
              this.dialogFormVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 工具栏样式
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
  
  .toolbar-right {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  
  .search-input {
    width: 220px;
    
    ::v-deep .el-input__inner {
      border-radius: 20px;
    }
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 统计卡片样式
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 160px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
    
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      
      &.total {
        background: linear-gradient(135deg, #1677ff, #4096ff);
      }
      
      &.top {
        background: linear-gradient(135deg, #00b578, #1acd8c);
      }
      
      &.child {
        background: linear-gradient(135deg, #e6a23c, #ebb563);
      }
    }
    
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1f2d3d;
        line-height: 1.2;
      }
      
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.el-table td {
  border-bottom: 1px solid #f0f0f0;
}

.el-table .el-table__row {
  transition: background 0.2s;
}

.el-table .el-table__row:hover {
  background: #f8f9fc;
}

// 部门名称样式
.dept-name {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 16px;
    color: #1677ff;
  }
  
  span {
    font-weight: 500;
    color: #1f2d3d;
  }
  
  .level-tag {
    margin-left: 8px;
  }
}

// 负责人样式
.contact-info, .phone-info {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 14px;
    color: #00b578;
  }
}

.time-text {
  font-size: 12px;
  color: #8c8f98;
}

// 操作按钮样式
.edit-btn {
  color: #1677ff;
  margin-right: 12px;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #4096ff;
  }
}

.delete-btn {
  color: #ff4d4f;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #ff7875;
  }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.el-pagination .el-pager li.active {
  background: #1677ff;
  color: #fff;
}

.el-pagination .el-pagination__total {
  color: #8c8f98;
}

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.alipay-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
  padding: 20px 24px;
}

.alipay-dialog .el-dialog__title {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.alipay-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 18px;
}

.alipay-dialog .el-dialog__body {
  padding: 24px;
}

.alipay-dialog .el-dialog__footer {
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f0f0;
}

.dialog-content .el-form-item {
  margin-bottom: 22px;
}

.dialog-content .el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.dialog-content .el-input__inner,
.dialog-content .el-textarea__inner,
.dialog-content .el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
}

.dialog-content .el-input__inner:focus,
.dialog-content .el-textarea__inner:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

.full-width {
  width: 100%;
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #8c8f98;
  
  i {
    margin-right: 4px;
    color: #1677ff;
  }
}

.dialog-footer {
  .el-button {
    border-radius: 20px;
    padding: 9px 24px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
  }
  
  .el-button--primary:hover {
    background: #4096ff;
    border-color: #4096ff;
  }
}
</style>